/* src/app/tools-components/table/table.component.scss */
/*# sourceMappingURL=table.component.css.map */
